import { storage } from "$lib/firebase";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";


export async function uploadDishImage(shop:Shop, dishName:string, file:File) {
    const imageRef = ref(storage, shop.owner_uid + "/" + dishName);
    await uploadBytes(imageRef, file);
}

export async function deleteDishImage(shop:Shop, dishName:string) {
    try {
        await deleteObject(ref(storage, shop.owner_uid + "/" + dishName));
    } catch (e) {
        console.log(e);
    }
}

export async function getPictureURL(owner_uid: string, name: string): Promise<string> {
    let url = "";

    const path = owner_uid + '/' + name;
    // console.log(path);

    try {
        url = await getDownloadURL(ref(storage, path));
    } catch (e) {
        url = "/transparent.png";
    }

    return url
}